import axios from 'axios'
import { useMutation, useQuery } from 'react-query'
import { getStoredUtms } from 'utils/universal/utmStorage'

const leadUrl = `${process.env.NEXT_PUBLIC_API_ROOT}/api/leads`

const useLeadById = (params, enabled) => useQuery(['leadId', params], async () => {
  const url = `${leadUrl}/find`
  const { data } = await axios.get(url, { params })
  return data
}, {
  enabled,
  refetchOnWindowFocus: false,
  refetchOnmount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 1000 * 60 * 24,
})

const useLead = (name) => useMutation(
  (content) => {
    /**
     * Atribución de campaña.
     *
     * Se resuelve aquí, en el único embudo por el que pasan todos los
     * formularios, y no en cada pantalla: antes sólo el paso "informacion" del
     * cotizador adjuntaba UTMs (por un `...router.query`), así que los leads de
     * cita, ofertas y financiamiento llegaban al CRM sin atribución.
     *
     * Los UTMs guardados van primero para que cualquier valor que el formulario
     * haya puesto explícitamente en `content` tenga prioridad. Si no hay UTMs
     * —tráfico orgánico o directo— `getStoredUtms()` devuelve `{}` y el lead
     * viaja exactamente igual que antes, sin llaves vacías.
     */
    const params = {
      origin: window.location.origin,
      form_name: name,
      domain: window.location.host,
      content: JSON.stringify({ ...getStoredUtms(), ...content }),
    }
    if (content?.leadId) {
      return axios.put(`${leadUrl}/${content?.leadId}`, params)
    }
    return axios.post(leadUrl, params)
  },
)

export { useLead, useLeadById }
